<app-modal [show]="show" (onHide)="close()" windowClass="window-95"
  [title]="translationManager.getTranslation('SupplierOfferItem') + '-' + (_data?.Name ?? '')">
  <div class="app-modal-content" style="width: 100%">
    <div>

      <!--            <div class="form-block amb-15">-->
      <!--                <div class="header">-->
      <!--                    <span>{{ translationManager.getTranslation('Општи подаци') }}</span>-->
      <!--                </div>-->
      <!--                <div class="content">-->
      <!--                    <div class="form-element amb-10"-->
      <!--                        [ngClass]="{ 'error': form.elements['name'].error.required || form.elements['name'].error.invalid }">-->
      <!--                        <label>{{ translationManager.getTranslation('Назив') }}</label>-->
      <!--                        <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">-->
      <!--                            <input type="text" [(ngModel)]="form.elements['name'].value" maxlength="100">-->
      <!--                        </div>-->
      <!--                        <div class="content" *ngIf="state === viewState.Details">-->
      <!--                            <div class="static">-->
      <!--                                <span>{{ form.elements['name'].value | appvalue }}</span>-->
      <!--                            </div>-->
      <!--                        </div>-->
      <!--                        <div class="errors">-->
      <!--                            <span *ngIf="form.elements['name'].error.required">-->
      <!--                                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је-->
      <!--                                обавезно за-->
      <!--                                унос') }}</span>-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <div class="form-block block-blue amb-15">
        <div class="header">
          <span>{{ translationManager.getTranslation('Описни елементи ставке') }} </span>
        </div>
        <div class="content">

          <div *ngIf="form.elements['creatingWayFreeForm'].state.visible">
            <div class="left">

              <div class="form-element amb-5"
                [ngClass]="{ 'error': form.elements['requestDescription'].error.required || form.elements['requestDescription'].error.invalid }">
                <label>{{ translationManager.getTranslation('Опис') }}</label>
                <!--                <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">-->
                <!--                                    <textarea maxlength="500" name="name"-->
                <!--                                              [(ngModel)]="form.elements['description'].value">-->
                <!--                                </textarea>-->
                <!--                </div>-->
                <div class="content">
                  <div class="static">
                    <span>{{ form.elements['requestDescription'].value | appvalue }}</span>
                  </div>

                </div>
                <!--                <div class="errors">-->
                <!--                                    <span *ngIf="form.elements['requestDescription'].error.required">-->
                <!--                                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је-->
                <!--                                      обавезно за-->
                <!--                                      унос') }}</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div class="right">

              <div class="form-element amb-5"
                [ngClass]="{ 'error': form.elements['description'].error.required || form.elements['description'].error.invalid }">
                <label>{{ translationManager.getTranslation('Опис') }}</label>
                <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                  <textarea maxlength="500" name="name" [(ngModel)]="form.elements['description'].value">
                                </textarea>
                </div>
                <div class="content" *ngIf="state === viewState.Details">
                  <div class="static">
                    <span>{{ form.elements['description'].value | appvalue }}</span>
                  </div>

                </div>
                <div class="errors">
                  <span *ngIf="form.elements['description'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
                    обавезно за
                    унос') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-block1" *ngIf="elements && elements.length > 0">
            <!--                        <div class="header">-->
            <!--                            <span>{{ translationManager.getTranslation('Елементи селектованог шаблона') }}</span>-->
            <!--                        </div>-->
            <div *ngFor="let element of elements; let i = index" class="amb-10">
              <div class="left">
                <element [element]="requestElements[i]" [state]="viewState.Details" [mode]="elementMode.Execution">
                </element>
              </div>
              <div class="center">
                <parameter-type [state]="viewState.Details" [model]="parameterTypes[i]"></parameter-type>
              </div>
              <div class="right">
                <!-- <p>Rale {{element}} </p> -->
                   <element [element]="elements[i]" [state]="state" [mode]="elementMode.Execution">
                </element>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="form-blocks">
        <div class="left">
          <div class="form-block">
            <div class="header">
              <span>{{ translationManager.getTranslation('Јединични подаци') }}</span>
            </div>
            <div class="content">

              <div class="form-element amb-10"
                [ngClass]="{ 'error': form.elements['amount'].error.required || form.elements['amount'].error.invalid }">
                <label>{{ translationManager.getTranslation('Количина') }}</label>

                <div class="static">
                  <!-- <span>{{ form.elements['amount'].value | appvalue }}</span> -->

                  <p-inputNumber
                  [(ngModel)]="form.elements['amount'].value"
                  mode="decimal"
                  [locale]= "localeService.locale()"
                  [minFractionDigits]="2"
                  [disabled]="true"
                ></p-inputNumber>

                </div>

                <div class="errors">
                  <span *ngIf="form.elements['amount'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
                    обавезно за
                    унос') }}</span>
                </div>
              </div>

              <div class="form-element amb-10"
                [ngClass]="{ 'error': form.elements['unitOfMeasure'].error.required || form.elements['unitOfMeasure'].error.invalid }">
                <label>{{ translationManager.getTranslation('Јединица мере') }}</label>

                <div class="static">
                  <span>{{ form.elements['unitOfMeasure'].value | appvalue }}</span>
                </div>

                <div class="errors">
                  <span *ngIf="form.elements['unitOfMeasure'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
                    обавезно за
                    унос') }}</span>
                </div>
              </div>

              <div class="form-element amb-10"
                [ngClass]="{ 'error': form.elements['currencyId'].error?.required || form.elements['currencyId'].error?.invalid }">
                <label>{{ translationManager.getTranslation('Валута') }}</label>

                <!--
                  <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                  <select [(ngModel)]="form.elements['currencyId'].value">
                    <option></option>
                    <option *ngFor="let currency of currencies" [value]="currency.id">{{
                      currency.name }}</option>
                  </select>
                </div>
                <div class="errors">
                  <span *ngIf="form.elements['currencyId'].error?.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
                    обавезно за
                    унос') }}</span>
                </div>

                <div class="content" *ngIf="state === viewState.Details">
                  <div class="static">
                    <span>{{ form.elements['currencyName'].value }}</span>
                  </div>
                </div>
              -->

                <div class="static">
                  <span>{{ form.elements['currencyName'].value }}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="form-block block-green">
            <div class="header">
              <span>{{ translationManager.getTranslation('Остали подаци') }}</span>
            </div>
            <div class="content">
              <div class="form-element amb-10">
                <label>{{ translationManager.getTranslation('Јединична цена') }}</label>

                <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">

                    <p-inputNumber
                      [(ngModel)]="form.elements['unitPrice'].value"
                      mode="decimal"
                      [locale]= "localeService.locale()"
                      [minFractionDigits]="2"
                      InputFloatNumber=true maxlength="24"
                      [disabled]="isAuctionStarted"
                      (onInput)="changeUnitPrice($event.value)"
                    ></p-inputNumber>


                </div>
                <div class="content" *ngIf="state === viewState.Details">
                  <div class="static">
                    <!-- <span>{{ form.elements['unitPrice'].value | appvalue }}</span> -->

                    <p-inputNumber
                        [(ngModel)]="form.elements['unitPrice'].value"
                        mode="decimal"
                        [locale]= "localeService.locale()"
                        [minFractionDigits]="2"
                        InputFloatNumber=true maxlength="24"
                        [disabled]="true"
                    ></p-inputNumber>

                  </div>
                </div>
              </div>
              <div class="form-element amb-10"
                [ngClass]="{ 'error': form.elements['additionalCost'].error?.required || form.elements['additionalCost'].error?.invalid }">
                <label>{{ translationManager.getTranslation('Додатни трошак') }}</label>
                <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">

                  <p-inputNumber
                  [(ngModel)]="form.elements['additionalCost'].value"
                  mode="decimal"
                  [locale]= "localeService.locale()"
                  [minFractionDigits]="2"
                  InputFloatNumber=true maxlength="24"
                  [disabled]="isAuctionStarted"
                  (onInput)="changeAdditionalCost($event.value)"
                  ></p-inputNumber>

                </div>
                <div class="content" *ngIf="state === viewState.Details">
                  <div class="static">
                    <!-- <span>{{ form.elements['additionalCost'].value | appvalue }}</span> -->

                    <p-inputNumber
                    [(ngModel)]="form.elements['additionalCost'].value"
                    mode="decimal"
                    [locale]= "localeService.locale()"
                    [minFractionDigits]="2"
                    InputFloatNumber=true maxlength="24"
                    [disabled]="true"
                    ></p-inputNumber>

                  </div>
                </div>
                <div class="errors">
                  <span *ngIf="form.elements['additionalCost'].error?.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
                    обавезно за
                    унос') }}</span>
                </div>
              </div>

              <div class="form-element amb-10">
                <label>{{ translationManager.getTranslation('Укупна цена') }}</label>
                <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit" readonly>

                  <p-inputNumber
                  [(ngModel)]="form.elements['totalPrice'].value"
                  mode="decimal"
                  [locale]= "localeService.locale()"
                  [minFractionDigits]="2"
                  InputFloatNumber=true maxlength="24"
                  [disabled] = "true"
                  ></p-inputNumber>
                   <!-- [disabled]="isAuctionStarted" -->

                </div>
                <div class="content" *ngIf="state === viewState.Details">
                  <div class="static">
                    <!-- <span>{{ form.elements['totalPrice'].value | appvalue }}</span> -->

                    <p-inputNumber
                    [(ngModel)]="form.elements['totalPrice'].value"
                    mode="decimal"
                    [locale]= "localeService.locale()"
                    [minFractionDigits]="2"
                    InputFloatNumber=true maxlength="24"
                    [disabled]="true"
                    ></p-inputNumber>

                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" *ngIf="state === viewState.Create || state === viewState.Edit" (click)="submit()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation("Сачувај") }}
    </button>
    <button (click)="close()" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation("Одустани") }}
    </button>
  </div>
</app-modal>

<message-modal #messageModal [title]="translationManager.getTranslation('Информације')"
  [buttons]="[{ id: 'OK', title: translationManager.getTranslation('У реду'), look: 'btn-success', lookIcon: 'fa-check' }]"></message-modal>
